// OzRunways export helpers.
// GPX  -> user waypoints + route (flight path) — OzRunways imports as User Waypoints / route.
// KML  -> spray/flight zone polygon + waypoint & hazard placemarks — OzRunways imports as a Graphic Overlay.

const esc = (s = "") => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const num = (n) => Number(n).toFixed(6);

export function buildGpx(tasks, title = "Air Log") {
  const wpts = [];
  const rtes = [];
  tasks.forEach((t) => {
    (t.waypoints || []).forEach((p, i) =>
      wpts.push(`  <wpt lat="${num(p.lat)}" lon="${num(p.lon)}"><name>${esc(t.name)} WP${i + 1}</name></wpt>`));
    (t.dangers || []).forEach((p, i) =>
      wpts.push(`  <wpt lat="${num(p.lat)}" lon="${num(p.lon)}"><name>HAZARD ${esc(t.name)} ${i + 1}</name><sym>Danger Area</sym></wpt>`));
    if ((t.waypoints || []).length > 1) {
      const pts = t.waypoints.map((p, i) => `    <rtept lat="${num(p.lat)}" lon="${num(p.lon)}"><name>WP${i + 1}</name></rtept>`).join("\n");
      rtes.push(`  <rte>\n    <name>${esc(t.name)}</name>\n${pts}\n  </rte>`);
    }
  });
  return `<?xml version="1.0" encoding="UTF-8"?>
<gpx version="1.1" creator="Air Log" xmlns="http://www.topografix.com/GPX/1/1">
  <metadata><name>${esc(title)}</name></metadata>
${wpts.join("\n")}
${rtes.join("\n")}
</gpx>`;
}

export function buildKml(tasks, title = "Air Log") {
  const parts = [];
  tasks.forEach((t) => {
    if ((t.zone || []).length >= 3) {
      const ring = [...t.zone, t.zone[0]].map((p) => `${num(p.lon)},${num(p.lat)},0`).join(" ");
      parts.push(`    <Placemark><name>${esc(t.name)} — flight/spray zone</name><styleUrl>#zone</styleUrl><Polygon><outerBoundaryIs><LinearRing><coordinates>${ring}</coordinates></LinearRing></outerBoundaryIs></Polygon></Placemark>`);
    }
    (t.waypoints || []).forEach((p, i) =>
      parts.push(`    <Placemark><name>${esc(t.name)} WP${i + 1}</name><Point><coordinates>${num(p.lon)},${num(p.lat)},0</coordinates></Point></Placemark>`));
    (t.dangers || []).forEach((p, i) =>
      parts.push(`    <Placemark><name>HAZARD — ${esc(t.name)} ${i + 1}</name><styleUrl>#hazard</styleUrl><Point><coordinates>${num(p.lon)},${num(p.lat)},0</coordinates></Point></Placemark>`));
  });
  return `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
    <name>${esc(title)} — flight tasks</name>
    <Style id="zone"><LineStyle><color>ff0ba5f5</color><width>2</width></LineStyle><PolyStyle><color>4d0ba5f5</color></PolyStyle></Style>
    <Style id="hazard"><IconStyle><color>ff0000ff</color><scale>1.1</scale></IconStyle></Style>
${parts.join("\n")}
  </Document>
</kml>`;
}

export const slug = (s = "job") => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 50) || "job";

export function downloadFile(filename, content, mime) {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
